import { useEffect, useRef, type ReactNode } from 'react';
import { X } from 'lucide-react';

interface Props {
  titulo: string;
  icono?: ReactNode;
  ancho?: boolean;
  children: ReactNode;
  pie?: ReactNode;
  alCerrar(): void;
}

export function Modal({ titulo, icono, ancho, children, pie, alCerrar }: Props) {
  const caja = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const alTeclear = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        alCerrar();
      }
    };
    document.addEventListener('keydown', alTeclear);
    // El foco entra al diálogo: si se queda en el botón que lo abrió, el
    // teclado sigue manejando la lista de atrás.
    caja.current?.focus();
    return () => document.removeEventListener('keydown', alTeclear);
  }, [alCerrar]);

  return (
    <div className="telon" onMouseDown={(e) => e.target === e.currentTarget && alCerrar()}>
      <div className={`modal${ancho ? ' modal--ancho' : ''}`} ref={caja} tabIndex={-1} role="dialog" aria-modal="true">
        <div className="modal__cabecera">
          {icono}
          <h2>{titulo}</h2>
          <button className="btn btn--fantasma btn--icono" onClick={alCerrar} aria-label="Cerrar">
            <X size={16} />
          </button>
        </div>
        <div className="modal__cuerpo">{children}</div>
        {pie && <div className="modal__pie">{pie}</div>}
      </div>
    </div>
  );
}

interface PropsConfirmar {
  titulo: string;
  mensaje: ReactNode;
  etiquetaConfirmar?: string;
  peligro?: boolean;
  alConfirmar(): void;
  alCerrar(): void;
}

export function Confirmar({ titulo, mensaje, etiquetaConfirmar = 'Confirmar', peligro, alConfirmar, alCerrar }: PropsConfirmar) {
  return (
    <Modal
      titulo={titulo}
      alCerrar={alCerrar}
      pie={
        <>
          <button className="btn" onClick={alCerrar}>
            Cancelar
          </button>
          <button
            className={`btn ${peligro ? 'btn--peligro' : 'btn--primario'}`}
            onClick={() => {
              alConfirmar();
              alCerrar();
            }}
          >
            {etiquetaConfirmar}
          </button>
        </>
      }
    >
      <div style={{ fontSize: 13, lineHeight: 1.5 }}>{mensaje}</div>
    </Modal>
  );
}
